/**
 * @flow
 */

/* eslint-disable */

"use strict";

/*::
import type { ConcreteFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type HeaderHorizontal_user$ref: FragmentReference;
export type HeaderHorizontal_user = {|
  +displayName: ?string,
  +isStaff: boolean,
  +$refType: HeaderHorizontal_user$ref,
|};
*/

const node /*: ConcreteFragment*/ = {
  kind: "Fragment",
  name: "HeaderHorizontal_user",
  type: "UserType",
  metadata: null,
  argumentDefinitions: [],
  selections: [
    {
      kind: "ScalarField",
      alias: null,
      name: "displayName",
      args: null,
      storageKey: null,
    },
    {
      kind: "ScalarField",
      alias: null,
      name: "isStaff",
      args: null,
      storageKey: null,
    },
  ],
};
// prettier-ignore
(node/*: any*/).hash = '702844031c79868934959f861767616e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/components/Layout/__generated__/HeaderHorizontal_user.graphql.js